export const RECENTLY_VIEWED_PRODUCTS_CLEANUP_TIME = 60 * 60 * 24 * 30 // 30 days
export const RECENTLY_VIEWED_PRODUCTS_KEY = 'recently_viewed_products'
export const MAX_COLORS_PER_PRODUCT = 5
export const MAX_SAVED_RECENTLY_VIEWED_PRODUCTS = 9 // Show 8 products in desktop and 9 products in mobile
export const MAX_PRODUCTS_DESKTOP = 8
export const MAX_PRODUCTS_MOBILE = 9
